/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Sign_Up_DescriptionInputs */

const en_common_sign_sign_up_description = /** @type {(inputs: Common_Sign_Sign_Up_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started for free`)
};

const zh_common_sign_sign_up_description = /** @type {(inputs: Common_Sign_Sign_Up_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始使用`)
};

/**
* | output |
* | --- |
* | "Get started for free" |
*
* @param {Common_Sign_Sign_Up_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_sign_up_description = /** @type {((inputs?: Common_Sign_Sign_Up_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Sign_Up_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_sign_up_description(inputs)
	return zh_common_sign_sign_up_description(inputs)
});
export { common_sign_sign_up_description as "common.sign.sign_up_description" }